<!-- <div
  class="flex gap-5 px-5 py-4 max-sm:gap-3 animate-pulse bg-[#DDDEE0] rounded-5"
>
  <div
    class="max-w-[146px] max-sm:max-w-[100px] w-full h-[146px] max-sm:h-[100px] bg-white rounded-full flex justify-center items-center"
  >
    <div
      class="animate-pulse bg-white max-w-[80px] h-[80px] max-sm:max-w-[60px] max-sm:h-[60px]"
    ></div>
  </div>
  <div class="flex flex-col w-full h-full gap-3 py-3">
    <div class="w-full h-4 bg-white animate-pulse"></div>
    <div class="w-full h-4 bg-white animate-pulse"></div>
    <div class="animate-pulse bg-white max-w-[110px] w-full mt-auto h-8"></div>
  </div>
</div> -->

<div class="animate-pulse bg-[#DDDEE0] w-full h-[400px]"></div>
